export function isNonNullable<T>(arg: T): arg is NonNullable<T> {
  return arg !== null && arg !== undefined;
}

export function unwrap<T>(arg: T, errorMessage?: string): NonNullable<T> {
  if (!isNonNullable(arg)) {
    throw new TypeError(errorMessage !== undefined ? errorMessage : "");
  }
  return arg;
}

export function unwrapOrNull<T>(arg: T | null | undefined): T | null {
  if (arg === undefined) return null;
  return arg;
}

export function removeUndefined<T>(obj: T) {
  return Object.entries(obj).reduce((acc, [key, val]) => {
    return val === undefined ? acc : { ...acc, [key]: val };
  }, {});
}
